import * as React from "react";
import {
    Credit,
    CreditStatus,
    CreditsRequest
} from "../../http/protocol";
import {ListView, ListViewProps, ListViewState} from "../ListView";
import {Form, FormListener} from "../form/Form";
import {CreditService} from "../../services/CreditService";
import {ColumnType} from "../list/list/ColumnType";
import {ActionType} from "../list/list/DataTable";
import {EntityDataTable} from "../list/list/EntityDataTable";
import {FormGroup} from "../form/FormGroup";
import {FormInput} from "../form/FormInput";
import {SelectInput} from "../form/SelectInput";
import {ListUtils} from "../list/list/ListUtils";
import {PagerModel} from "../list/list/PagerModel";
import {getContainer} from "../../ioc/IOCSetup";
import {Alert} from "../form/Alert";
import {withRouter} from "react-router";



interface State extends ListViewState<CreditsRequest> {
    listRequest?: CreditsRequest,
    form?: CreditsRequest,
    availableCurrencies?: string[];
    validationMap? : any;
    operatorError?: boolean;
    credits : Credit[];
}

export class CreditListView extends ListView<State, CreditsRequest> implements FormListener<CreditsRequest> {


    creditService : CreditService;

    columns = [
        { property : "id", name : "ID", orderBy : "id"},
        { property : "reference", name : "Reference" },
        { property : "status", name : "Status", type: ColumnType.ENUM },
        { property : "originalAmount", name : "Amount" },
        { property : "owedAmount", name : "Owed" },
        { property : "created", name : "Created", orderBy : "created", type: ColumnType.DATE },
        { property : "userId", name : "User ID", type : ColumnType.LINK, getUrl : (item : Credit) => "/user/" + item.userId},
        { property : "accountId", name : "Account ID", type : ColumnType.LINK, getUrl : (item : Credit) => "/account/" + item.accountId},
        { property : "adminUserIdUpdated", name : "Admin ID" },
        { property : "updated", name : "Updated", orderBy : "updated", type:  ColumnType.DATE }
    ];

    actions = [
        { id : "view", name : "View", className : "btn btn-primary", iconClassName : "fa fa-eye", type : ActionType.LINK, getLink : (item : Credit)=> "/credit/" + item.id}
    ];

    constructor(props : ListViewProps) {
        super(props,"/credits");

        let listRequest =  {  limit: 50, ascending: false, orderBy: "id"};

        let locProp = this.props.location;
        if(locProp.state && locProp.state.listRequest) {
            listRequest = Object.assign(listRequest,{ status: locProp.state.listRequest.status && locProp.state.listRequest.status});
        }
        this.state =  {...this.state, validationMap : {}, form : {...listRequest}, listRequest : listRequest, availableCurrencies : [], };

        this.creditService = getContainer().getCreditService();
    }


    formDidUpdate(formModel: CreditsRequest, validationMap : any): void {
        this.setState({ form : formModel, validationMap : validationMap});
    }

    onSubmitError(): void {

    };

    onSubmit(): void {
        let listRequest : CreditsRequest = Object.assign({},this.state.form);
        listRequest.offset = 0;
        if(!listRequest.userId) listRequest.userId = undefined;
        if(!listRequest.reference) listRequest.reference = undefined;
        this.updateListState(listRequest);
    };

    filterEmpty(o: any): any {
        if (o == null  ||  o === undefined  ||  o === "") {
            return undefined;
        } else {
            return o;
        }
    }


    pagerChanged(pager : PagerModel) {
        if(!this.state.listRequest){
            return;
        }
        var listRequest = ListUtils.toListRequest(this.state.listRequest, pager);
        this.setState({listRequest : listRequest});
    }

    onAction(item : Credit, action : string) : undefined | Promise<any> {
        return;
    }

    getTitle() {
        return "Credits";
    }

    getSearchByUserId() {
        return (
            <div className="row">
                <div className="col-lg-6">
                    <div className="card-box">
                        <Form formListener={this} modelObject={this.state.form}
                            validationMap={this.state.validationMap}>
                            <FormGroup className="form-group">
                                <label className="col-lg-2 control-label">Reference</label>
                                <div className="col-lg-10">
                                    <FormInput className="form-control" model="reference" type={"string"} />
                                </div>
                            </FormGroup>
                            <div className="form-group">
                                <div className="col-lg-offset-2 col-lg-10">
                                    <input className="btn btn-primary" value="Search" type={"submit"} />
                                </div>
                            </div>

                        </Form>
                    </div>
                </div>
                <div className="col-lg-6">
                    <div className="card-box">
                        <Form formListener={this} modelObject={this.state.form}
                            validationMap={this.state.validationMap}>
                            <FormGroup className="form-group">
                                <label className="col-lg-2 control-label">User Id</label>
                                <div className="col-lg-10">
                                    <FormInput className="form-control" model="userId" type={"number"} />
                                </div>
                            </FormGroup>
                            <div className="form-group">
                                <div className="col-lg-offset-2 col-lg-10">
                                    <input className="btn btn-primary" value="Search" type={"submit"} />
                                </div>
                            </div>

                        </Form>
                    </div>
                </div>
            </div>
        );
    }

    getSearchByFilter() {
        return (
            <div className="card-box expandable-box" style={!this.state.lookupExpanded ? { cursor: "pointer" } : { cursor: "default" }} onClick={() => !this.state.lookupExpanded ? this.setState({ lookupExpanded: true }) : null}>
                {this.state.lookupExpanded && (
                    <a className="expand-button float-right"  onClick={() => this.setState({ lookupExpanded: false })}><i className="mdi mdi-minus"></i></a>
                )}
                {!this.state.lookupExpanded && (
                    <a className="expand-button float-right"  onClick={() => this.setState({ lookupExpanded: true })}><i className="mdi mdi-plus"></i></a>
                )}
                <h4 className="header-title mb-3" onClick={() => this.setState({ lookupExpanded: !this.state.lookupExpanded })}>Advanced Search</h4>
                <br/>
                {this.state.lookupExpanded && (
                    <div>
                        <Form formListener={this} modelObject={this.state.form} validationMap={this.state.validationMap}>
                            <div className="row">
                                <div className="col-lg-4">
                                    <FormGroup className="form-group">
                                        <label className="col-lg-2 control-label">Status</label>
                                        <div className="col-lg-10">
                                            <SelectInput size={1} className="form-control" model="status" optional={true}
                                                values={Object.values(CreditStatus).sort()} multiple={false} />
                                        </div>
                                    </FormGroup>
                                </div>
                                <div className="col-lg-8">
                                    <FormGroup className={"form-group"}>
                                        <label htmlFor={"startDate"}>From:</label>
                                        <FormInput model={"startDate"} className={"form-control col-lg-6"} type={"date"} />
                                        <label htmlFor={"endDate"}>To:</label>
                                        <FormInput model={"endDate"} className={"form-control col-lg-6"} type={"date"}  />
                                        <span className={"help-text"}>To but not included</span>
                                    </FormGroup>
                                </div>
                                <div className="col-lg-6">
                                    <div className="form-group">
                                        <div className="col-lg-offset-2 col-lg-10">
                                            <input className="btn btn-primary" value="Search" type={"submit"} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Form>
                    </div>
                )}
            </div>
        );
    }


    renderContent() {
        console.log(this.state)
        return (
            <div>
                {this.state.operatorError && (
                    <Alert type="danger" text={"One of user id or account id is required"}/>
                )}
                {this.getSearchByUserId()}
                {this.getSearchByFilter()}

                <EntityDataTable
                    service={this.creditService}
                    onPagerChange={this.pagerChanged.bind(this)}
                    columns={this.columns}
                    listRequest={this.state.listRequest}
                    onAction={this.onAction.bind(this)}
                    actions={this.actions}
                />
            </div>
        );
    }

}

export default withRouter(CreditListView)